import React from "react";
import { CSSTransition /*, TransitionGroup*/ } from "react-transition-group";
//import styles from "./styles.less";

export default props => {
  const { children } = props;
  return (
    children && (
      //<TransitionGroup className={styles.wrapper}>
      <CSSTransition
        in={children && children.key}
        appear={true}
        timeout={300}
        classNames="fade"
        unmountOnExit
      >
        {children}
      </CSSTransition>
      //</TransitionGroup>
    )
  );
};

{
  /* <Transitioner>
  <component key={someValueRequired}/>
  </Transitioner> */
}



// WEBPACK FOOTER //
// ./src/components/common/Transitioner/Transitioner.js